import { jsx } from "react/jsx-runtime";
import { typography } from "../typography/typography.js";
import { ErrorIcon } from "./components/ErrorIcon/ErrorIcon.js";
import { InfoIcon } from "./components/InfoIcon/InfoIcon.js";
import { SuccessIcon } from "./components/SuccessIcon/SuccessIcon.js";
import { WarningIcon } from "./components/WarningIcon/WarningIcon.js";
import "../typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../typography/utils/typographyVariants/typographyVariants.js";
import "@mui/material/SvgIcon/index.js";
const MuiAlert = {
  defaultProps: {
    iconMapping: {
      info: /* @__PURE__ */ jsx(InfoIcon, {}),
      error: /* @__PURE__ */ jsx(ErrorIcon, {}),
      warning: /* @__PURE__ */ jsx(WarningIcon, {}),
      success: /* @__PURE__ */ jsx(SuccessIcon, {})
    }
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      display: "flex",
      alignItems: "center",
      color: theme.palette.grey[800],
      padding: "8px 16px",
      boxShadow: theme.shadows[2],
      wordBreak: "keep-all",
      ...typography["Lato Caption Bold"],
      ...ownerState.severity === "success" && {
        backgroundColor: theme.palette.success[50]
      },
      ...ownerState.severity === "warning" && {
        backgroundColor: theme.palette.warning[50]
      },
      ...ownerState.severity === "info" && {
        backgroundColor: theme.palette.highlight1[50]
        // blue1 mapped to highlight1
      },
      ...ownerState.severity === "error" && {
        color: theme.palette.error[800],
        backgroundColor: theme.palette.error[50]
      }
    }),
    icon: {
      padding: 0,
      opacity: 1
    },
    message: {
      padding: 0
    }
  }
};
export {
  MuiAlert
};
